import { ActionTypes } from '../actions';
import { MAX_ZOOM, MIN_ZOOM, ZOOM_INCREMENT } from '../../common/constants';

export type IZoomState = number;
export const initialState: number = 1.5;

const zoomReducer = (zoom: IZoomState = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.ZOOM_IN: {
      return zoom < MAX_ZOOM ? zoom + ZOOM_INCREMENT : zoom;
    }
    case ActionTypes.ZOOM_OUT: {
      return zoom > MIN_ZOOM ? zoom - ZOOM_INCREMENT : zoom;
    }
    default: {
      return zoom;
    }
  }
};

export default zoomReducer;
